import React from "react";

const SelectComponent = ({ label, name, options, required, value, handleChange, disabled }) => {
  return (
    <>
      <div className="mx-2 mb-2">
        <label
          className="block mb-2 text-sm font-medium text-white"
        >
          {label}
        </label>
        <select
          value={value}
          required={required}
          name={name}
          disabled={disabled}
          onChange={(e) => {
            handleChange(e)
          }}
          className="bg-202531 border-0 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        >
          <option value="" selected>Choose {label}</option>
          {options?.map((itm, index) => {
            return (
              <option key={index} value={itm?.value}>
                {itm?.label}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
};

export default SelectComponent;